import { render, staticRenderFns } from "./envelopes.vue?vue&type=template&id=afce9e84&scoped=true&"
import script from "./envelopes.vue?vue&type=script&lang=js&"
export * from "./envelopes.vue?vue&type=script&lang=js&"
import style0 from "./envelopes.vue?vue&type=style&index=0&id=afce9e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afce9e84",
  null
  
)

export default component.exports